import { ExportLog } from 'common/models'
import { keyBy } from 'lodash'
import { ActionType, getType } from 'typesafe-actions'

import * as logsActions from './actionCreators'

export type LogActionType = ActionType<typeof logsActions>

interface LogsState {
  exportLogs: Dict<any>
}

const initialState: Readonly<LogsState> = {
  exportLogs: {},
}

export default (state = initialState, action: LogActionType) => {
  switch (action.type) {
    case getType(logsActions.getExportLogs.success): {
      const exportLogs: Dict<ExportLog> = keyBy(action.payload, '_id')
      return {
        ...state,
        exportLogs,
      }
    }
    default:
      return state
  }
}
